import {
    Component,
    Input,
    OnInit,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
    ReferentielService,
    ReponseQuestionnaireSante,
} from '@kv-common-components/kx-services';
import { MotifComponent } from './motif/motif.component';
@Component({
    selector: 'app-question-motif-component',
    templateUrl: './question-motif.component.html',
    styleUrls: ['./question-motif.component.scss'],
})
export class QuestionMotifComponent implements OnInit {
    @ViewChildren(MotifComponent) motifComponents!: QueryList<MotifComponent>;
    @Input() qsForm: FormGroup = new FormGroup({});
    @Input() questionQuestionnaireSante: any;
    motifs: any[];
    extraPanelVisible = false;
    charCounter = 0;
    // Todo get from conf
    configMaxCharCounter = 500;
    maxCharCounter: number;
    private nbSeperatorForOneMotif: number;

    constructor(protected referentielService: ReferentielService) {}

    ngOnInit(): void {
        this.qsForm.addControl(
            this.questionQuestionnaireSante.numero,
            new FormControl(null, Validators.required)
        );
        this.motifs = [];
        this.nbSeperatorForOneMotif =
            this.questionQuestionnaireSante.listeSousQuestions.filter(
                (sousQuestion) =>
                    ['medicament', 'analyse', 'chaine', 'maladie'].includes(
                        sousQuestion.type
                    )
            ).length - 1;
        this.addMotif();
    }

    addMotif() {
        this.motifs.push({ controlId: this.motifs.length });
        this.updateMaxChar();
    }
    showExtraPanel() {
        this.extraPanelVisible = true;
        if (this.motifs.length === 0) {
            this.addMotif();
        }
    }
    hideExtraPanel() {
        this.extraPanelVisible = false;
    }
    removeMotif(motifToRemove: any) {
        this.motifs = this.motifs.filter((item) => item !== motifToRemove);
        if (this.motifs.length === 0) {
            this.extraPanelVisible = false;
            this.qsForm.controls[
                this.questionQuestionnaireSante.numero
            ].setValue(null);
        }
        this.updateMaxChar();
        this.updateCharCounter(motifToRemove.controlId);
    }
    getReponse(): ReponseQuestionnaireSante {
        const reponse: ReponseQuestionnaireSante = {
            id: this.questionQuestionnaireSante.id,
            numero: this.questionQuestionnaireSante.numero,
            ouiNon: null,
        };
        if (
            this.qsForm.controls[this.questionQuestionnaireSante.numero]
                .value !== null
        ) {
            reponse.ouiNon = this.qsForm.controls[
                this.questionQuestionnaireSante.numero
            ].value
                ? 'oui'
                : 'non';
        }
        if (this.extraPanelVisible) {
            reponse.listeReponsesSousQuestionSante = [];
            this.motifComponents.forEach((motif) => {
                reponse.listeReponsesSousQuestionSante.push(motif.getMotif());
            });
        }
        return reponse;
    }

    updateMaxChar() {
        this.maxCharCounter =
            this.configMaxCharCounter -
            this.nbSeperatorForOneMotif * this.motifs.length;
    }
    updateCharCounter(controlId?: string) {
        this.charCounter = 0;
        this.motifComponents
            .filter((motif) => motif.controlId !== controlId)
            .forEach((motif) => {
                this.charCounter += motif.getCharCounter();
            });
    }
}
